/** Generally we should use Playwright's locators (https://playwright.dev/docs/api/class-locator) to
 * get UI elements without the need for data- constants. However some copmonents like <svg>s an be
 * very tricky to reliably locate, so we can use data-test-ids with these constants to make this easier.
 */
const dataTestids = {
  LAYOUT: {
    AUTHED_NAVBAR: 'authed-navbar',
    UNAUTHED_NAVBAR: 'unauthed-navbar',
    HEADER: {
      LOGO: 'layout-header-logo',
      MOBILE_SIDEPANEL: 'layout-header-mobile-sidepanel',
      MOBILE_SIDEPANEL_BUTTON: 'layout-header-mobile-sidepanel-button',
      ABOUT_US: 'layout-header-about-us',
      WHAT_WE_OFFER: 'layout-header-what-we-offer',
      IMPACT: 'layout-header-impact',
      RESOURCES: 'layout-header-resources',
    },
    FOOTER: {
      LOGO: 'layout-footer-logo',
      YOUTUBE: 'layout-footer-youtube',
      LINKED_IN: 'layout-footer-linked-in',
    },
    PROFILE_DROPDOWN: 'layout-profile-dropdown',
    ORG_DROPDOWN: 'layout-org-dropdown',
  },
  DASHBOARD: {
    HEADER: 'dashboard-header',
    NAVBAR: {
      LOGO: 'dashboard-navbar-logo',
      TEXT: 'dashboard-navbar-text',
    },
    LEFTNAV: 'left-nav-container',
    SEARCH_STATUS: {
      POSTPONED_DATEPICKER: 'dashboard-search-postponed-until',
    },
  },
  CREATE_PROJECT: {
    STEP_HEADER: 'create-project-step-header',
    COMPLETED_STEP_BUSINESS_CHALLENGE: 'create-project-completed-step-business-challenge',
    COMPLETED_STEP_SKILLS: 'create-project-completed-step-skills',
    COMPLETED_STEP_SUPPORT_TYPES: 'create-project-completed-step-support-types',
    BUSINESS_CHALLENGE_ROW: 'create-project-business-challenge-row',
    BUSINESS_CHALLENGE_SELECT_BUTTON: 'create-project-business-challenge-select-button',
    SUPPORT_TYPE_ROW: 'create-project-support-type-row',
    SUPPORT_TYPE_SELECT_BUTTON: 'create-project-support-type-select-button',
  },
  MY_PROJECTS: {
    PROJECT_CARD: {
      CONTAINER: 'my-projects-project-card-container',
    },
  },
  ADMIN_TEAMS: {
    MEMBER_EDIT_MODAL: {
      CURRENT_MEMBER: 'current-member',
      NEW_MEMBER: 'new-member',
      DELETED_MEMBER: 'deleted-member',
    },
  },
  ADMIN_ORGS: {
    ORG_EDIT_MODAL: {
      CURRENT_MEMBER: 'current-member',
    },
  },
  ADMIN_LAYOUT: {
    TABLE_HEADER_CELL: 'admin-layout-table-header-cell',
    TABLE_HEADER_FILTER_BUTTON: 'admin-layout-table-header-filter-button',
  },
} as const;

export default dataTestids;
